import _ from "lodash";
import * as utils from "./klevu/utils";
import { css, getHotPrice } from "./utils";
import { getDiscountWithClearanceBadgePrefixText, getStyle } from "./utils";
import { callApi } from "./api";

const TOTAL_OF_RESUTL = 108;

function post(url, body, convertData = (data) => Promise.resolve(data)) {
    return fetch(url, {
			method: 'POST',
			body: JSON.stringify(body),
			crossDomain: true,
		})
		.then((response) => response.json())
		.then(convertData);
}

function displayPrices(dataLocal) {
	let displayPriceText = '';
    window.KNOCKDOWN_STYLING = window.KNOCKDOWN_STYLING || {};

	if ((dataLocal['saleAvailability'] !== undefined && dataLocal['saleAvailability'] !== '' && dataLocal['saleAvailability'].toUpperCase() === 'ISONP')) {
		displayPriceText += `<p class="productItem-price--original">${dataLocal['detailDisplay'] || ''}</p>`;
	} else {
		if (dataLocal['originalPriceText'] != undefined && dataLocal['originalPriceText'] !== '') {
			displayPriceText += `<p class="productItem-price--original">${dataLocal['originalPriceText'] || ''}</p>`;
		}
		if ((dataLocal['isClearancePrice'] !== undefined && dataLocal['isClearancePrice'] !== '' && dataLocal['isDiscountPrice'].toLowerCase() === 'true') || dataLocal['isDiscountPrice'] === true ||
			(dataLocal['isClearancePrice'] !== undefined && dataLocal['isClearancePrice'] !== '' && dataLocal['isClearancePrice'].toLowerCase() === 'true') || dataLocal['isClearancePrice'] === true ||
            (dataLocal['isKnockDownPrice'] !== undefined && dataLocal['isKnockDownPrice'] !== '' && dataLocal['isKnockDownPrice'].toLowerCase() === 'true') || dataLocal['isKnockDownPrice'] === true ||
			(dataLocal['isHotPrice'] !== undefined && dataLocal['isHotPrice'] !== '' && dataLocal['isHotPrice'].toLowerCase() === 'true') || dataLocal['isHotPrice'] === true) {
			if (dataLocal['wasPriceText'] != undefined && dataLocal['wasPriceText'] !== '') {
				displayPriceText += `<p class="productItem-price--original">${dataLocal['wasPriceText'] || ''}</p>`;
			}
			displayPriceText += `<p class="productItem-price--discount">${dataLocal['discountPriceText'] || ''}</p>`;
		} else {
			displayPriceText += `<p class="productItem-price--original">${dataLocal['discountPriceText'] || ''}</p>`;
		}
        if (((dataLocal['isKnockDownPrice'] !== undefined && dataLocal['isKnockDownPrice'] !== '' && dataLocal['isKnockDownPrice'].toLowerCase() === 'true') || dataLocal['isKnockDownPrice'] === true) && window.KNOCKDOWN_STYLING.Text) {
            displayPriceText += `<p class="productItem-subTitle">${window.KNOCKDOWN_STYLING.Text}</p>`;
        }
		if (dataLocal['specialOffersText'] != undefined && dataLocal['specialOffersText'] !== '') {
			displayPriceText += `<p class="productItem-subTitle">${dataLocal['specialOffersText'] || ''}</p>`;
		}
	}

	return displayPriceText;
}

function displayBadges(dataLocal) {
	let badges = '';
	let badgesCount = 0;
    window.KNOCKDOWN_STYLING = window.KNOCKDOWN_STYLING || {};
	const isClearance = (dataLocal["isClearancePrice"] !== undefined  && dataLocal["isClearancePrice"] !== "" && dataLocal["isClearancePrice"].toLowerCase() === "true") || dataLocal["isClearancePrice"] === true;
	const isDiscountPrice = !!dataLocal['discount'];
	const isHotPrice = !!dataLocal['discountHP'];

	if (dataLocal['saleAvailability'] === undefined || dataLocal['saleAvailability'].toUpperCase() !== 'ISONP') {
		if (isClearance) {
			badges += `<div class="productItem-label productItem-label--clearance"><span>CLEARANCE</span></div>`;
			badgesCount++;
			if (isDiscountPrice) {
				badges += `<div class="productItem-label productItem-label--discount" style="${getStyle(window.DISCOUNT_WITH_CLEARANCE_STYLE)}">
					<span>${getDiscountWithClearanceBadgePrefixText(window.DISCOUNT_WITH_CLEARANCE_STYLE.Text || dataLocal["discount"])}</span>
				</div>`;
				badgesCount++;
			}
        } else if ((dataLocal['isKnockDownPrice'] !== undefined && dataLocal['isKnockDownPrice'] !== '' && dataLocal['isKnockDownPrice'].toLowerCase() === 'true') || dataLocal['isKnockDownPrice'] === true) {
            if (dataLocal['discount'] !== undefined && dataLocal['discount'] !== '') {
                badges += `<div class="productItem-label productItem-label--sale"><span>${dataLocal['discount']}</span></div>`;
                badgesCount++;
            }
            badges += `<div class="productItem-label productItem-label--knockdown" style="${window.KNOCKDOWN_STYLING.CustomStyle}"><span>${window.KNOCKDOWN_STYLING.Badge}</span></div>`;
            badgesCount++;
		} else if (isDiscountPrice || isHotPrice) {
			if (isDiscountPrice) {
				badges += `<div class="productItem-label productItem-label--sale" style="${css({'background-color': dataLocal['discountBadgeBgColor'] || ''})}" ><span>${dataLocal['discount']}</span></div>`;
				badgesCount++;
			}
			if (isHotPrice) {
				badges += `<div class="productItem-label productItem-label--new"><span>${getHotPrice(dataLocal['discountHP'] || '')}</span></div>`;
				badgesCount++;
			}
		}
	}
	if (!isClearance && (badgesCount < 2 && (window.NEW_IN_STYLING && (dataLocal['isNewIn'] !== undefined && dataLocal['isNewIn'] !== '' && dataLocal['isNewIn'].toLowerCase() === 'true') || dataLocal['isNewIn'] === true))) {
		badges += `<div style="color: ${window.NEW_IN_STYLING.Color}; background: ${window.NEW_IN_STYLING.BackgroundColor};" class="productItem-label productItem-label--custom">
			<span>${window.NEW_IN_STYLING.Text}</span>
		</div>`;
		badgesCount++;
	}
	if (badgesCount === 0) {
		if ((dataLocal['badgeName0'] !== undefined && dataLocal['badgeName0'] !== '')) {
			badges += `<div class="productItem-label productItem-label--custom" style="color: ${dataLocal.badgeTextColor0}; background-color: ${dataLocal.badgeBgColor0}"><span>${dataLocal['badgeName0']}</span></div>`;
		}
		if ((dataLocal['badgeName1'] !== undefined && dataLocal['badgeName1'] !== '')) {
			badges += `<div class="productItem-label productItem-label--custom" style="color: ${dataLocal.badgeTextColor1}; background-color: ${dataLocal.badgeBgColor1}"><span>${dataLocal['badgeName1']}</span></div>`;
		}
	}
	if (badgesCount === 1) {
		if ((dataLocal['badgeName0'] !== undefined && dataLocal['badgeName0'] !== '')) {
			badges += `<div class="productItem-label productItem-label--custom" style="color: ${dataLocal.badgeTextColor0}; background-color: ${dataLocal.badgeBgColor0}"><span>${dataLocal['badgeName0']}</span></div>`;
		}
	}

	return badges ? `<div class="productItem-labelWrap">${badges}</div>` : '';
}

function displayColorWrap(dataLocal) {
    let colors = '';
    const getColorTag = (color) => {
        let tag = '';
        if (color.ImageUrl) {
            tag += `<img src="${color.ImageUrl}" alt="${color.ColourName}"/>`;
        } else if (color.colourSwatch) {
            tag += `<span class="hexColour" style="${color.colourSwatch}"></span>`;
        } else if (color.VariantImageUrl) {
            tag += `<img src="${color.VariantImageUrl}" alt="${color.ColourName}"/>`;
        }
        if (color.IsOutOfStock === 'True') {
            tag += `<div class="productItem-color--shadow"></div>`;
        }

        return tag;
    };

    if (dataLocal.bundleColor || dataLocal.productColor) {
        utils.showColor(
            (dataLocal.bundleColor || dataLocal.productColor),
            (color) => {
                colors += `
                <div class="productItem-color--option"
                    data-item-description="${color.ColourName}"
                    data-variant-code="${color.ColourCode}"
                    data-sku="${color.Sku}">
                    ${getColorTag(color)}
                </div>
                `;
            },
            (more) => {
                colors += `
                <div class="productItem-color--option productItem-color--option--blank">
                    <span class="hexColour">+${more}</span>
                </div>`;
            }
        );
    }

    if (colors) {
        return `
        <div class="productItem-colorWrap">
            <div class="productItem-color">${colors}</div>
        </div>`;
    }
    return '';
}

function getInlineRating(dataLocal) {
    if (dataLocal['isBundle'] === undefined || dataLocal['isBundle'] === 'False') {
        return `<div data-bv-show="inline_rating" data-bv-product-id="${dataLocal.id}"></div>`;
    }
    return '';
}

function displayBonusBuy(dataLocal) {
	let bonusBuyBadges = '';
	let hasBonus = true;
	let i = 0;
	while (hasBonus) {
		let bonusBadge = `bonusBuyBadgeName${i}`;
		let bonusBadgeColor = `bonusBuyBadgeTextColor${i}`;
		let bonusBadgeBg = `bonusBuyBadgeBgColor${i}`;
		if ((dataLocal[bonusBadge] !== undefined && dataLocal[bonusBadge] !== '')) {
			bonusBuyBadges += `<div class="bonus-buy-badge" style="color: ${dataLocal[bonusBadgeColor]}; background-color: ${dataLocal[bonusBadgeBg]};">${dataLocal[bonusBadge]}</div>`;
		} else {
			hasBonus = false;
		}
		i++;
	}
	return bonusBuyBadges ? bonusBuyBadges : '';
}

export function convertData(data) {
	if (utils.enableVisitorGroupDiscount()) {
		return new Promise((resolve) => {
			callApi('/api/brisproduct/product-prices/', {
				productCodes: data.queryResults[0].records.map(({ productCode }) => productCode),
			}).then((staffDiscount) => {
				staffDiscount.forEach((discount) => {
					const record = data.queryResults[0].records.find((record) => record.productCode === discount.code);
					if (record) {
						klevu.extend(record, discount, {
							isDiscountPrice: (discount.isDiscountPrice || discount.isDiscountPrice === 'True') ? 'true' : 'false',
						});
					}
				});
				resolve(data.queryResults[0].records.map(getProduct));
			}).catch((e) => {
				resolve(data.queryResults[0].records.map(getProduct));
			});
		});
	} else {
		const productRecommendation = data.queryResults[0].records.map(getProduct);
		return Promise.resolve(productRecommendation);
	}
}


export function getImage(dataLocal) {
	if (window.USE_THUMBNAIL_IMAGE && window.USE_THUMBNAIL_IMAGE === 'True' && dataLocal.thumbnailImage) {
		return decodeURIComponent(dataLocal.thumbnailImage);
	} else {
		return dataLocal.image;
	}
}

export function convertDataWithFallback(data) {
	if (utils.enableVisitorGroupDiscount()) {
		return new Promise((resolve) => {
			callApi('/api/brisproduct/product-prices/', {
				productCodes: data.queryResults.reduce((acc, queryResult) => {
					const productCodes = queryResult.records.map(({ productCode }) => productCode);
					return acc.concat(productCodes);
				}, []),
			}).then((staffDiscount) => {
				staffDiscount.forEach((discount) => {
					data.queryResults.map((queryResult) => {
						const record = queryResult.records.find((record) => record.productCode === discount.code);
						if (record) {
							klevu.extend(record, discount, {
								isDiscountPrice: (discount.isDiscountPrice || discount.isDiscountPrice === 'True') ? 'true' : 'false',
							});
						}
					});
				});
				resolve(data.queryResults.map((queryResult) => queryResult.records.map(getProduct)));
			}).catch((e) => {
				resolve(data.queryResults.map((queryResult) => queryResult.records.map(getProduct)));
			});
		});
	} else {
		const results = data.queryResults.map((queryResult) => queryResult.records.map(getProduct));
		return Promise.resolve(results);
	}
}

function getProduct(record) {
	const getBoolean = (value) => value === 'True';
	return {
		'title': record.displayTitle,
		'code': record.productCode,
		'url': record.url,
		'type': '',
		'isClearancePrice': getBoolean(record.isClearancePrice),
		'isHotPrice': getBoolean(record.isHotPrice),
		'isDiscountPrice': getBoolean(record.isDiscountPrice),
		'isNewInVisible': getBoolean(record.isNewIn),
		'newInText': '',
		'newInTextBackgroundColour': '',
		'newInTextColor': '',
		'displayPrice': displayPrices(record),
		'displayBadge': displayBadges(record),
        'displayColorWrap': displayColorWrap(record),
		'shippingPromotionInfo': null,
		'saleAvailability': record.saleAvailability || '',
		'inlineRating': getInlineRating(record),
		'bonusBuy': displayBonusBuy(record),
		'images': [{
			'zoom': record.imageUrl || '',
			'detail': record.imageUrl || '',
			'thumb': getImage(record) || '',
			'alt': null,
			'video': null,
		}],
	};
}

export function getKlevuConfig() {
    const $endpoinds = $('.endpoints-definition');
    let klevuConfig = {
        searchUrl: null,
        apiKey: null,
    };

    if ($endpoinds.length) {
        const endpoindStringMap = $endpoinds[0].dataset;
        klevuConfig = {
            searchUrl: endpoindStringMap.searchUrl,
            apiKey: endpoindStringMap.apiKey,
        };
    }

    return klevuConfig;
}

function applyFilter(filters = [], backupfilters = null, limit = TOTAL_OF_RESUTL) {
    const config = {
        context: {
            apiKeys: [getKlevuConfig().apiKey],
        },
        recordQueries: [getRecordQueries(filters, 'productList', limit)],
    };

    if (backupfilters) {
		if (_.isArray(backupfilters)) {
			config.recordQueries.push(getRecordQueries(backupfilters, 'fallback', limit));
		} else {
			for (const key in backupfilters) {
				config.recordQueries.push(getRecordQueries(backupfilters[key], key, limit));
			}
		}
    }

    return config;
}

function getRecordQueries(filters, id = 'productList', limit = TOTAL_OF_RESUTL) {
    return {
        id,
        typeOfRequest: 'SEARCH',
        settings: {
            typeOfRecords: [
                'KLEVU_PRODUCT',
            ],
            limit,
            searchPrefs: [
                'searchCompoundsAsAndQuery',
                'hideOutOfStockProducts',
            ],
            sort: 'RELEVANCE',
        },
        filters: {
            applyFilters: {
                filters,
            },
        },
    };
}

export function searchByFilters(filters, convertData = null, backupfilters = null, limit = TOTAL_OF_RESUTL) {
	const payload = applyFilter(filters, backupfilters, limit);
    const url = getKlevuConfig().searchUrl;

	return post(url, payload, convertData);
}



// WEBPACK FOOTER //
// ./klevuService.js